<template>
  <button class="comment-card" @click="openComment">
    <div class="d-flex justify-content-between align-items-end fs-14">
      <div class="header-text">
        <div
          v-if="comment.parent_id"
          class="d-flex d-lg-block flex-column mb-2"
        >
          <span :class="{ 'text-alert-500': comment.parent_id }">
            {{
              comment.moderator_data
                ? comment.moderator_data.name
                : comment.name || "Usuário sem nome"
            }}
          </span>
          <span class="text-neutral-500">
            em resposta ao comentário de
          </span>
          <span class="text-information-600">
            {{
              comment.parent.moderator_data
                ? comment.parent.moderator_data.name
                : comment.parent.name || "Usuário sem nome"
            }}
          </span>
        </div>

        <div class="class-info" :class="{ 'mb-3': !comment.parent_id }">
          <span v-if="comment.lesson_name" class="text-neutral-500">
            {{ comment.lesson_name }}
          </span>
          <span v-if="comment.module_name" class="module-name">
            {{ comment.module_name }}
          </span>
        </div>
      </div>

      <div class="buttons">
        <bp-tooltip
          v-if="
            comment.status === 'published' &&
              comment.parent_id &&
              comment.parent.status !== 'published'
          "
          text="Aprove o comentário principal para manipular esta resposta."
        >
          <button
            disabled
            class="btn btn-40 btn-square btn-new-outline-secondary mr-3"
          >
            <i class="fa-regular fa-eye-slash" />
          </button>
        </bp-tooltip>
        <button
          v-else-if="comment.status === 'published'"
          class="btn btn-40 btn-square btn-new-outline-secondary mr-3"
          @click.stop="blockComment(comment.id)"
        >
          <i class="fa-regular fa-eye-slash" />
        </button>
        <bp-tooltip
          text="Aprove o comentário principal para manipular esta resposta."
          v-else-if="comment.parent_id && comment.parent.status !== 'published'"
        >
          <button class="btn btn-40 btn-new-outline-success mr-3" disabled>
            <i class="fa-regular fa-check" />
          </button>
        </bp-tooltip>
        <button
          v-else
          class="btn btn-40 btn-new-outline-success mr-3"
          @click.stop="$emit('update', 'published', comment.id)"
        >
          <i class="fa-regular fa-check" />
        </button>
        <button
          class="btn btn-40 btn-new-outline-danger"
          @click.stop="$emit('delete', comment)"
        >
          <i class="fa-regular fa-trash" />
        </button>
      </div>
    </div>

    <comment :comment="comment" class="mt-3" />

    <div class="d-flex justify-content-end align-items-center mt-3 fs-12">
      <span
        class="mr-2"
        :class="comment.likes > 0 ? 'text-primary' : 'text-neutral-500'"
        @click.stop="like"
      >
        {{ comment.likes }}
        <i class="fa-heart" :class="comment.likes ? 'fa' : 'fa-regular'" />
      </span>
      <div v-if="!comment.parent_id" class="d-flex">
        <!-- <span v-if="unreadChildren.length" class="unread-messages ml-2">
          {{ unreadChildren.length }}
          resposta{{ unreadChildren.length > 1 ? "s" : "" }} nova{{
            unreadChildren.length > 1 ? "s" : ""
          }}
          <i class="fa fa-message px-2" />
        </span> 
        insert v-else in the element bellow
      -->
        <span
          :class="
            comment.num_children > 0 ? 'text-primary' : 'text-neutral-500'
          "
        >
          {{ comment.num_children }}
          <i
            class="fa-message"
            :class="comment.num_children ? 'fa' : 'fa-regular'"
          />
        </span>
      </div>
    </div>
  </button>
</template>
<script>
import moment from "moment";
import Comment from "./Comment";
export default {
  props: {
    comment: Object
  },
  components: { Comment },
  computed: {
    userPicture() {
      return (
        this.comment.user_photo ||
        require("@/assets/images/avatar-placeholder.png")
      );
    },
    postDate() {
      return moment(this.comment.created_at).fromNow(true);
    },
    unreadChildren() {
      return this.comment.children.filter(c => !c.read);
    }
  },
  methods: {
    openComment() {
      this.$emit("reply", this.comment);
      // let unreadComments = [this.comment, ...this.comment.children].filter(
      //   c => !c.read
      // );
      // if (unreadComments.length) {
      //   Promise.all(unreadComments.map(this.read)).finally(() =>
      //     this.$emit("refresh")
      //   );
      // }
    },
    blockComment(id) {
      this.$store
        .dispatch("membersComments/updateMany", {
          comments: [{ id, status: "blocked" }]
        })
        .then(() => this.$emit("refresh"))
        .catch(() => this.$message.error("Erro ao atualizar comentário"));
    },
    read(comment) {
      return this.$store.dispatch("membersComments/update", {
        id: comment.id,
        read: true
      });
    },
    like() {
      this.comment.liked = !this.comment.liked;
      this.comment.likes = this.comment.liked
        ? this.comment.likes + 1
        : this.comment.likes - 1;
      this.$store
        .dispatch("membersComments/like", this.comment.id)
        .catch(() => {
          this.comment.liked = !this.comment.liked;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.comment-card {
  max-width: 100%;
  padding: 16px;
  text-align: left;
  border-radius: 6px;
  transition: 0.2s all;
  background: #f5f5f7;
  border: 1px solid #e0e0e3;
  &:hover {
    border-color: #ccaafd;
    box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08);
  }
  .header-text {
    max-width: calc(100% - 110px);
    .class-info {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 2px;
      .module-name {
        font-size: 12px;
        white-space: nowrap;
        color: $neutral-400;
      }
    }
  }
  .buttons {
    min-width: 100px;
  }
  .unread-messages {
    padding: 4px;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(153, 85, 255, 0.87);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);

    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(120, 30, 255, 0.88);
  }
}
</style>
